var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.415 4.25C20.985 4.25 21.415 4.75 21.185 5.68L18.395 18.83C18.2 19.765 17.635 19.99 16.855 19.555L10.2 14.64C10.1742 14.6215 10.1532 14.5971 10.1387 14.5688C10.1242 14.5406 10.1166 14.5093 10.1166 14.4775C10.1166 14.4457 10.1242 14.4144 10.1387 14.3862C10.1532 14.3579 10.1742 14.3335 10.2 14.315L14.885 9.375C15.235 9.065 14.81 8.915 14.35 9.195L7.70504 13.28C7.67579 13.2991 7.64258 13.3112 7.60793 13.3156C7.57328 13.3199 7.53809 13.3163 7.50504 13.305L3.41004 12.01C2.50004 11.745 2.50004 11.12 3.61504 10.675L20 4.355C20.13 4.29266 20.2711 4.25696 20.415 4.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tgIcon.9777545ceff6b0be24596e395656205e.svg";
export { ForwardRef as ReactComponent };